module.exports = __webpack_public_path__ + "media/documents.cc334542.mp3";